/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbSharedRedirectedItem_viewer$ref = any;
export type SbSharedRedirectedItemRefetchQueryVariables = {
    itemId: string;
    hasItemId: boolean;
};
export type SbSharedRedirectedItemRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": SbSharedRedirectedItem_viewer$ref;
    } | null;
};
export type SbSharedRedirectedItemRefetchQuery = {
    readonly response: SbSharedRedirectedItemRefetchQueryResponse;
    readonly variables: SbSharedRedirectedItemRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasItemId",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SbSharedRedirectedItemRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SbSharedRedirectedItem_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "hasItemId",
                "variableName": "hasItemId"
              },
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SbSharedRedirectedItemRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasItemId",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "item",
                "storageKey": null,
                "args": [
                  (v1/*: any*/)
                ],
                "concreteType": "Item",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "photos",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemPhoto",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "smallPath",
                        "args": null,
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ]
                  },
                  (v2/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SbSharedRedirectedItemRefetchQuery",
    "id": "app-buyer-finding/237.0.0-2019-10-16T15:08:56.780Z/SbSharedRedirectedItemRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '6a24ee67f7c147b42cc0d66f5d28c0d2';
export default node;
